import apiClient from './client'

export interface DicionarioDadosRecord {
  id: number
  banco: string
  tabela: string
  coluna: string
  label_formulario?: string | null
  label_grid?: string | null
  descritivo_help?: string | null
  prompt_ia?: string | null
  tipo_dado?: string | null
  obrigatorio: boolean
  tamanho_maximo?: number | null
  valores_possiveis?: string | null
  ativo: boolean
  created_at?: string | null
  updated_at?: string | null
  created_by?: number | null
  updated_by?: number | null
}

export type DicionarioDadosSortField =
  | 'id'
  | 'banco'
  | 'tabela'
  | 'coluna'
  | 'label_formulario'
  | 'label_grid'
  | 'tipo_dado'
  | 'obrigatorio'
  | 'ativo'
  | 'created_at'
  | 'updated_at'

export interface DicionarioDadosListParams {
  banco?: string
  tabela?: string
  coluna?: string
  ativo?: boolean
  texto?: string
  sort_by?: DicionarioDadosSortField
  sort_direction?: 'asc' | 'desc'
  limit?: number
  offset?: number
}

export interface DicionarioDadosCreatePayload {
  banco: string
  tabela: string
  coluna: string
  label_formulario?: string | null
  label_grid?: string | null
  descritivo_help?: string | null
  prompt_ia?: string | null
  tipo_dado?: string | null
  obrigatorio?: boolean
  tamanho_maximo?: number | null
  valores_possiveis?: string | null
  ativo?: boolean
}

export interface DicionarioDadosUpdatePayload {
  banco?: string | null
  tabela?: string | null
  coluna?: string | null
  label_formulario?: string | null
  label_grid?: string | null
  descritivo_help?: string | null
  prompt_ia?: string | null
  tipo_dado?: string | null
  obrigatorio?: boolean | null
  tamanho_maximo?: number | null
  valores_possiveis?: string | null
  ativo?: boolean | null
}

export const dicionarioDadosApi = {
  list: async (
    params: DicionarioDadosListParams = {}
  ): Promise<DicionarioDadosRecord[]> => {
    const response = await apiClient.get<DicionarioDadosRecord[]>(
      '/dicionario-dados',
      { params }
    )
    return response.data
  },

  get: async (id: number): Promise<DicionarioDadosRecord> => {
    const response = await apiClient.get<DicionarioDadosRecord>(
      `/dicionario-dados/${id}`
    )
    return response.data
  },

  create: async (
    payload: DicionarioDadosCreatePayload
  ): Promise<DicionarioDadosRecord> => {
    const response = await apiClient.post<DicionarioDadosRecord>(
      '/dicionario-dados',
      payload
    )
    return response.data
  },

  update: async (
    id: number,
    payload: DicionarioDadosUpdatePayload
  ): Promise<DicionarioDadosRecord> => {
    const response = await apiClient.put<DicionarioDadosRecord>(
      `/dicionario-dados/${id}`,
      payload
    )
    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/dicionario-dados/${id}`)
  },
}
